/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Magiclinkfailed2Inputs */

const zh_auth_magiclinkfailed2 = /** @type {(inputs: Auth_Magiclinkfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送登录链接失败`)
};

const en_auth_magiclinkfailed2 = /** @type {(inputs: Auth_Magiclinkfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send magic link`)
};

const es_auth_magiclinkfailed2 = /** @type {(inputs: Auth_Magiclinkfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al enviar el enlace mágico`)
};

/**
* | output |
* | --- |
* | "Failed to send magic link" |
*
* @param {Auth_Magiclinkfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_magiclinkfailed2 = /** @type {((inputs?: Auth_Magiclinkfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Magiclinkfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_magiclinkfailed2(inputs)
	if (locale === "en") return en_auth_magiclinkfailed2(inputs)
	return es_auth_magiclinkfailed2(inputs)
});
export { auth_magiclinkfailed2 as "auth_magicLinkFailed" }